export enum TaskCreationMode {
  Created = 'created',
  Updated = 'updated',
  Restored = 'restored',
  Generated = 'generated',
}
